module.exports = __webpack_public_path__ + "img/on1.ff26ef20.gif";